import React from 'react';
import { estados } from '../constants';
import { Navigation } from '../components/FormControls';
import { StepProps } from './sectionTypes';
import { formatPhone } from '../utils';

export const EnderecoStep = ({
  form,
  etapaCompleta,
  updateForm,
  input,
  onPrev,
  onNext,
  buscandoCep,
  cepErro,
  buscarCep
}: StepProps & {
  buscandoCep: boolean;
  cepErro: string;
  buscarCep: (value: string) => void;
}) => (
  <section className="form-section">
    <h2><span className="section-icon">📍</span>Endereço</h2>
    <div className="form-group">
      <label htmlFor="cep">CEP *</label>
      <div className="input-with-loader">
        <input id="cep" type="text" placeholder="00000-000" value={form.cep} onChange={(event) => buscarCep(event.target.value)} required />
        {buscandoCep && <span className="loader" />}
      </div>
      {cepErro && <div className="error-message">{cepErro}</div>}
    </div>
    <div className="form-group">
      <label htmlFor="endereco">Endereço *</label>
      <input id="endereco" type="text" required disabled={buscandoCep} {...input('endereco')} />
    </div>
    <div className="form-row">
      <div className="form-group">
        <label htmlFor="numero">Número *</label>
        <input id="numero" type="text" required {...input('numero')} />
      </div>
      <div className="form-group">
        <label htmlFor="complemento">Complemento</label>
        <input id="complemento" type="text" {...input('complemento')} />
      </div>
    </div>
    <div className="form-row">
      <div className="form-group">
        <label htmlFor="bairro">Bairro *</label>
        <input id="bairro" type="text" required disabled={buscandoCep} {...input('bairro')} />
      </div>
      <div className="form-group">
        <label htmlFor="cidade">Cidade *</label>
        <input id="cidade" type="text" required disabled={buscandoCep} {...input('cidade')} />
      </div>
    </div>
    <div className="form-row">
      <div className="form-group">
        <label htmlFor="uf">UF *</label>
        <select id="uf" required disabled={buscandoCep} {...input('uf')}>
          <option value="">Selecione...</option>
          {estados.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="telefoneResidencial">Telefone Residencial</label>
        <input id="telefoneResidencial" type="text" placeholder="(00) 0000-0000" value={form.telefoneResidencial} onChange={(event) => updateForm('telefoneResidencial', formatPhone(event.target.value))} />
      </div>
    </div>
    <Navigation disabled={!etapaCompleta[2]} onPrev={onPrev} onNext={onNext} />
  </section>
);
